// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"88386597","268":"b8e9f4df","282":"79e3447e","321":"52eccd60","397":"8ecc34a9","538":"60cb4d9c","563":"78bbd916","668":"2f7fd909","780":"b0c06007","915":"acb7e497","968":"e1d00db4"}[chunkId] + ".chunk.js";
};